import { observer } from 'mobx-react';
import LoadingIndicator from '../../../../../../../LoadingIndicator';
import Modal from '../../../../../../../Modal';

export interface Props {
  close: () => void;
}

function LoadingModal({ close }: Props) {
  return (
    <Modal
      close={close}
      title={<></>}
      customBackgroundCssClasses="bg-teal-100 opacity-60"
      modalWidth="w-2/5"
    >
      <LoadingIndicator
        className="mx-auto"
        type="bubbles"
        color="black"
        height={100}
        width={100}
        delay={0}
      />
    </Modal>
  );
}

export default observer(LoadingModal);
